/**
 * The scale warning of `Light3D::get_configuration_warnings()` (light_3d.cpp:181-189),
 * for every descendant through `applicableNodeTypeMatcher`, AreaLight3D included
 * through `UNCATALOGUED`. Light3D is abstract, and `RuleRegistry` matches
 * `applicableNodeTypes` by exact name.
 */
import { ruleRegistry } from '../../../../linter/RuleRegistry.js';
import { descendsFromClass } from '../../../../godot/classdb/classBaseTypes.js';
import { hasNonUnitScale3D } from '../../../../linter/transformBasis.js';
import { armDiagnostic, armEmits, groundedArm } from '../../../../linter/ruleArms.js';
const arms = {
    nonUnitScale: groundedArm('light3d-non-unit-scale', { kind: 'configuration-warning' }),
};
function checkLight3DScale(context) {
    const { node } = context;
    // Only `transform` serialises the pose (node_3d.cpp:1526-1531). `Basis::get_scale()`
    // (core/math/basis.cpp:299-321) folds one det sign across all axes and
    // `decomposeTransform3D` into one axis, but a reflection leaves an axis negative
    // under both, so they agree on `(1, 1, 1)`, as in `xrorigin3d/linter.ts`.
    if (!hasNonUnitScale3D(node.rawProperties.transform))
        return [];
    return [
        armDiagnostic(arms.nonUnitScale, node, `${node.type} '${node.name}' has a non-unit scale. A light's scale does not affect the visual size of the light, the same configuration warning Godot's own editor reports.`),
    ];
}
const light3DScaleValidationRule = {
    meta: {
        name: 'valid-light3d-scale',
        description: "Mirrors Light3D::get_configuration_warnings' own-scale check across every concrete light type",
        category: 'validation',
        applicableNodeTypeMatcher: (nodeType) => descendsFromClass(nodeType, 'Light3D'),
        emits: armEmits(arms),
    },
    check: checkLight3DScale,
};
ruleRegistry.register(light3DScaleValidationRule);
//# sourceMappingURL=linter.js.map